import { configureStore } from "@reduxjs/toolkit";
import conversationSlice from './app/conversations/conversationSlice';
import analyticsReducer from './analyticsSlice';
import assistantReducer from './app/assistantSlice';
import userReducer from './app/userSlice';
import orgReducer from './app/organizationSlice';
import walletReducer from './app/walletSlice';

const store = configureStore({
  reducer: {
    conversation: conversationSlice,
    analytics: analyticsReducer,
    assistants: assistantReducer,
    user: userReducer, 
    orgData: orgReducer,
    walletData: walletReducer
  },
});

export default store;
